import getFirebaseAuth from 'actions/firebase/auth'
import { signInWithEmailAndPassword } from 'firebase/auth'

const adminLogin = async (email, password) => signInWithEmailAndPassword(getFirebaseAuth(), email, password)

export default adminLogin
